import http from "./axios";

const listSystemQualification = ({ name, visible, enabled, modelId }) => {
  return http.get("/manager/qualification/listSystemQualification", {
    name,
    visible,
    enabled,
    modelId,
  });
};

const list = () => {
  return http.get("/manager/formModel/list");
};

const listPlatformQualification = ({ name, platformId, enabled, modelId }) => {
  return http.get("/manager/qualification/listPlatformQualification", {
    name,
    platformId,
    enabled,
    modelId,
  });
};

const listSystemHideInfo = ({ optionId }) => {
  return http.get("/manager/qualificationHide/listSystemHideInfo", {
    optionId,
  });
};

const listPlatformHideInfo = ({ optionId, platformId }) => {
  return http.get("/manager/qualificationHide/listPlatformHideInfo", {
    optionId,
    platformId,
  });
};

const queryRelationOptionByOptionId = ({
  optionId,
  labelId,
  filterDisabledPlatform,
}) => {
  return http.get("/manager/qualification/queryRelationOptionByOptionId", {
    optionId,
    labelId,
    filterDisabledPlatform,
  });
};

const queryRelationOptionByPlatformOptionId = ({
  platformOptionId,
  platformLabelId,
}) => {
  return http.get(
    "/manager/qualification/queryRelationOptionByPlatformOptionId",
    {
      platformOptionId,
      platformLabelId,
    }
  );
};

const modifySystemLabelOption = ({ id, order, content }) => {
  return http.json_post("/manager/qualification/modifySystemLabelOption", {
    id,
    order,
    content,
  });
};

const modifyPlatformLabelOption = ({ id, order, content, value }) => {
  return http.json_post("/manager/qualification/modifyPlatformLabelOption", {
    id,
    order,
    content,
    value,
  });
};

const modifySystemLabelName = ({ id, name }) => {
  return http.json_post("/manager/qualification/modifySystemLabelName", {
    id,
    name,
  });
};

const modifyPlatformLabelName = ({ id, name }) => {
  return http.json_post("/manager/qualification/modifyPlatformLabelName", {
    id,
    name,
  });
};

const modifySystemLabelVisible = ({ id, enabled }) => {
  return http.json_post("/manager/qualification/modifySystemLabelVisible", {
    id,
    enabled,
  });
};

const modifySystemLabelEnabled = ({ id, enabled }) => {
  return http.json_post("/manager/qualification/modifySystemLabelEnabled", {
    id,
    enabled,
  });
};

const modifyPlatformLabelEnabled = ({ id, enabled }) => {
  return http.json_post("/manager/qualification/modifyPlatformLabelEnabled", {
    id,
    enabled,
  });
};

const addBindRelation = ({
  type,
  labelId,
  optionIdList,
  platformId,
  platformLabelId,
  platformOptionId,
  value,
  modelId,
}) => {
  return http.json_post("/manager/qualification/addBindRelation", {
    type,
    labelId,
    optionIdList,
    platformId,
    platformLabelId,
    platformOptionId,
    value,
    modelId,
  });
};

const cleanBindInfo = ({ id, platformOptionId }) => {
  return http.json_post("/manager/qualification/cleanBindInfo", {
    id,
    platformOptionId,
  });
};

const addSystemLabelOption = ({ labelId, content, enabled, modelId }) => {
  return http.json_post("/manager/qualification/addSystemLabelOption", {
    labelId,
    content,
    enabled,
    modelId,
  });
};

const addPlatformLabelOption = ({
  labelId,
  content,
  enabled,
  value,
  modelId,
}) => {
  return http.json_post("/manager/qualification/addPlatformLabelOption", {
    labelId,
    content,
    enabled,
    value,
    modelId,
  });
};

const deletePlatformLabelOption = ({ id }) => {
  return http.json_post("/manager/qualification/deletePlatformLabelOption", {
    id,
  });
};

const deleteSystemLabelOption = ({ id }) => {
  return http.json_post("/manager/qualification/deleteSystemLabelOption", {
    id,
  });
};

const modifySystemLabelDefaultValue = ({
  labelId,
  defaultType,
  defaultValue,
}) => {
  return http.json_post(
    "/manager/qualification/modifySystemLabelDefaultValue",
    {
      labelId,
      defaultType,
      defaultValue,
    }
  );
};

const modifyPlatformLabelDefaultValue = ({
  labelId,
  defaultType,
  defaultValue,
}) => {
  return http.json_post(
    "/manager/qualification/modifyPlatformLabelDefaultValue",
    {
      labelId,
      defaultType,
      defaultValue,
    }
  );
};

const modifyBindRelation = ({
  id,
  type,
  labelId,
  optionId,
  platformId,
  platformLabelId,
  platformOptionId,
  platformOptionIdList,
  value,
  modelId,
}) => {
  return http.json_post("/manager/qualification/modifyBindRelation", {
    id,
    type,
    labelId,
    optionId,
    platformId,
    platformLabelId,
    platformOptionId,
    platformOptionIdList,
    value,
    modelId,
  });
};

const deleteSystemLabel = ({ id }) => {
  return http.json_post("/manager/qualification/deleteSystemLabel", {
    id,
  });
};

const deletePlatformLabel = ({ id }) => {
  return http.json_post("/manager/qualification/deletePlatformLabel", {
    id,
  });
};

const changeSystemLabelType = ({ id, type, modelId }) => {
  return http.json_post("/manager/qualification/changeSystemLabelType", {
    id,
    type,
    modelId,
  });
};

const changePlatformLabelType = ({ id, type, modelId }) => {
  return http.json_post("/manager/qualification/changePlatformLabelType", {
    id,
    type,
    modelId,
  });
};

const saveLabelOrder = ({ sortedIdList, system }) => {
  return http.json_post("/manager/qualification/saveLabelOrder", {
    sortedIdList,
    system,
  });
};

const addSystemLabel = ({ name, type, field, visible, modelId }) => {
  return http.json_post("/manager/qualification/addSystemLabel", {
    name,
    type,
    field,
    visible,
    modelId,
  });
};

const addPlatformLabel = ({ name, type, field, platformId, modelId }) => {
  return http.json_post("/manager/qualification/addPlatformLabel", {
    name,
    type,
    field,
    platformId,
    modelId,
  });
};

const deleteSystemHideInfo = ({ id }) => {
  return http.json_post("/manager/qualificationHide/deleteSystemHideInfo", {
    id,
  });
};

const deletePlatformHideInfo = ({ id }) => {
  return http.json_post("/manager/qualificationHide/deletePlatformHideInfo", {
    id,
  });
};

const addSystemHideInfo = ({ labelId, optionId, modelId }) => {
  return http.json_post("/manager/qualificationHide/addSystemHideInfo", {
    labelId,
    optionId,
    modelId,
  });
};

const addPlatformHideInfo = ({ labelId, optionId, platformId, modelId }) => {
  return http.json_post("/manager/qualificationHide/addPlatformHideInfo", {
    labelId,
    optionId,
    platformId,
    modelId,
  });
};

export default {
  listSystemQualification,
  list,
  listPlatformQualification,
  queryRelationOptionByOptionId,
  queryRelationOptionByPlatformOptionId,
  modifySystemLabelOption,
  modifySystemLabelName,
  modifySystemLabelVisible,
  modifySystemLabelEnabled,
  modifyPlatformLabelName,
  modifyPlatformLabelOption,
  modifyPlatformLabelEnabled,
  addBindRelation,
  cleanBindInfo,
  addSystemLabelOption,
  deleteSystemLabelOption,
  deletePlatformLabelOption,
  addPlatformLabelOption,
  modifySystemLabelDefaultValue,
  modifyPlatformLabelDefaultValue,
  modifyBindRelation,
  deleteSystemLabel,
  deletePlatformLabel,
  changePlatformLabelType,
  changeSystemLabelType,
  saveLabelOrder,
  addPlatformLabel,
  addSystemLabel,
  listSystemHideInfo,
  listPlatformHideInfo,
  deleteSystemHideInfo,
  deletePlatformHideInfo,
  addSystemHideInfo,
  addPlatformHideInfo,
};
